import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const VportFullscreenIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 0H15.7C15.1 0 14.7 0.4 14.7 1C14.7 1.6 15.1 2 15.7 2H20.6L15.3 7.3C14.9 7.7 14.9 8.3 15.3 8.7C15.7 9.1 16.3 9.1 16.7 8.7L22 3.4V8.3C22 8.9 22.4 9.3 23 9.3C23.6 9.3 24 8.9 24 8.3V1C24 0.4 23.6 0 23 0Z"
        fill={color}
      />
      <path
        d="M23 14.7C22.4 14.7 22 15.1 22 15.7V20.6L16.7 15.3C16.3 14.9 15.7 14.9 15.3 15.3C14.9 15.7 14.9 16.3 15.3 16.7L20.6 22H15.7C15.1 22 14.7 22.4 14.7 23C14.7 23.6 15.1 24 15.7 24H23C23.6 24 24 23.6 24 23V15.7C24 15.1 23.6 14.7 23 14.7Z"
        fill={color}
      />
      <path
        d="M8.3 22H3.4L8.7 16.7C9.1 16.3 9.1 15.7 8.7 15.3C8.3 14.9 7.7 14.9 7.3 15.3L2 20.6V15.7C2 15.1 1.6 14.7 1 14.7C0.4 14.7 0 15.1 0 15.7V23C0 23.6 0.4 24 1 24H8.3C8.9 24 9.3 23.6 9.3 23C9.3 22.4 8.9 22 8.3 22Z"
        fill={color}
      />
      <path
        d="M8.3 0H1C0.4 0 0 0.4 0 1V8.3C0 8.9 0.4 9.3 1 9.3C1.6 9.3 2 8.9 2 8.3V3.4L7.3 8.7C7.7 9.1 8.3 9.1 8.7 8.7C9.1 8.3 9.1 7.7 8.7 7.3L3.4 2H8.3C8.9 2 9.3 1.6 9.3 1C9.3 0.4 8.9 0 8.3 0Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

VportFullscreenIcon.displayName = 'VportFullscreenIcon';
